const CROCKFORD = '0123456789ABCDEFGHJKMNPQRSTVWXYZ'

function randomBytes(n: number): Uint8Array {
  const out = new Uint8Array(n)
  crypto.getRandomValues(out)
  return out
}

let lastTime = -1
let lastRandom: number[] = []

/**
 * ULID (26 chars, Crockford base32): 48-bit ms timestamp + 80 bits randomness.
 * Monotonic within a process so ids created in the same ms still sort by creation.
 */
export function ulid(now: number = Date.now()): string {
  let rand: number[]
  if (now <= lastTime && lastRandom.length === 16) {
    // Increment the previous randomness (base32 digits) to stay monotonic.
    rand = lastRandom.slice()
    for (let i = rand.length - 1; i >= 0; i--) {
      if (rand[i]! < 31) {
        rand[i]!++
        break
      }
      rand[i] = 0
    }
    now = lastTime
  } else {
    const bytes = randomBytes(16)
    rand = Array.from(bytes, (b) => b & 31)
  }
  lastTime = now
  lastRandom = rand

  let time = ''
  let t = now
  for (let i = 0; i < 10; i++) {
    time = CROCKFORD[t % 32]! + time
    t = Math.floor(t / 32)
  }
  return time + rand.map((r) => CROCKFORD[r]).join('')
}

export function ulidTime(id: string): number | null {
  if (id.length !== 26) return null
  let t = 0
  for (let i = 0; i < 10; i++) {
    const v = CROCKFORD.indexOf(id[i]!)
    if (v < 0) return null
    t = t * 32 + v
  }
  return t
}

export function isUlid(id: string): boolean {
  return /^[0-9A-HJKMNP-TV-Z]{26}$/.test(id)
}

/** URL-safe random token. 16 bytes = 128 bits (share tokens, SPEC §13.2). */
export function randomToken(bytes = 16): string {
  return base64url(randomBytes(bytes))
}

export function base64url(bytes: Uint8Array): string {
  let bin = ''
  for (const b of bytes) bin += String.fromCharCode(b)
  return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

export function base64urlDecode(s: string): Uint8Array {
  const b64 = s.replace(/-/g, '+').replace(/_/g, '/') + '==='.slice((s.length + 3) % 4)
  const bin = atob(b64)
  const out = new Uint8Array(bin.length)
  for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i)
  return out
}

/** Short id for attachments etc. */
export function shortId(): string {
  return base64url(randomBytes(9))
}
